import { SubAPI } from "./SubAPI";
export class ProjectWorkOrder extends SubAPI {
    get(props) { return this.fetcher.get("/api/project-work-order/item", props); }
    upsert(props) { return this.fetcher.post("/api/project-work-order/item", props); }
}
